import '../LoginStyle.css';
import Popup from './Popup';
import { useState } from 'react';

function Email() {
  const [isOpen, setIsOpen] = useState(false);
  const handlePopup = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="container">
      <h2 className="title"> Reset Password</h2>
      <div className="box">
        <p className="text">Email</p>
        <input className="input" placeholder="email" />
        <button className="btn" onClick={handlePopup}>
          Enter
        </button>
        {isOpen && <Popup handleClose = {handlePopup}/>}
      </div>
    </div>
  );
}

export default Email;
